import type { Component } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Form from '~/components/Form'
import GeoSelects from '~/components/GeoSelects'
import Input from '~/components/Input'
import Select from '~/components/Select'
import type { TabGeneralProps } from './types'

const TabGeneral: Component<TabGeneralProps> = props => {
  return (
    <>
      <Card>
        <Card.Header>Información general</Card.Header>
        <Card.Body>
          <Form id="general-form" onSubmit={props.handleSaveGeneral} initialValues={props.initialValues(props.data)}>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <Select
                name="tipoPersona"
                label="Tipo de persona"
                options={[
                  { value: 'natural', title: 'Persona natural' },
                  { value: 'juridica', title: 'Persona jurídica' }
                ]}
                value={props.data.tipoPersona}
              />
              <Select name="documentType" label="Tipo de documento" options={props.documentOptions()} value={props.data.documentType ?? 'CC'} />
              <Input name="document" label="Número de documento" />
              <Input name="digitoVerificacion" label="Dígito de verificación (NIT)" />
              <Input name="name" label="Nombre / razón social" required />
              <Input name="lastName" label="Apellido" />
              <Input name="razonSocial" label="Razón social" class="lg:col-span-2" />
              <Input name="nombreComercial" label="Nombre comercial" class="lg:col-span-2" />
              <Input name="phone" label="Teléfono" />
              <Input name="celular" label="Celular" />
              <Input name="email" label="Correo" type="email" class="lg:col-span-2" />
              <Input name="paginaWeb" label="Página web" class="lg:col-span-2" />
              <Input name="address" label="Dirección" class="lg:col-span-2" />
              <Input name="barrio" label="Barrio" />
              <GeoSelects
                namePais="pais"
                nameDepartamento="departamento"
                nameCiudad="ciudad"
                valuePais={props.initialValues(props.data).pais as string}
                valueDepartamento={props.initialValues(props.data).departamento as string}
                valueCiudad={props.initialValues(props.data).ciudad as string}
                class="lg:col-span-3 md:grid-cols-3"
              />
              <Input name="codigoPostal" label="Código postal" />
            </div>
          </Form>
        </Card.Body>
      </Card>
      <div class="flex justify-end mt-4">
        <Button type="submit" form="general-form" disabled={props.isSaving()}>
          Guardar
        </Button>
      </div>
    </>
  )
}

export default TabGeneral
